import { Box, Button, Paper, Stack, Typography } from "@mui/material"
//import HttpsIcon from "@mui/icons-material/Https"
import OrderItem8 from "./OrderDetails/OrderItem8"
import {
  IProductPrice,
  TPaymentMethodEnum,
} from "../../../../core/types/Product"
import { useCheckoutContext } from "../../../../core/hooks/useCheckoutContext"
import NumberFunctions from "../../../../core/functions/NumberFunctions"

const paymentsInstallment = [
  TPaymentMethodEnum.CreditCard,
  TPaymentMethodEnum.TwoCreditCard,
  TPaymentMethodEnum.CreditCardAndPix,
]

interface ICheckoutButtonCommit8Props {
  data: IProductPrice | null
  paymentMethodType: number
  paymentInstallment: number
  paymentTotal: number
  paymentValue: number
}

const CheckoutButtonCommit8 = ({
  data,
  paymentMethodType,
  paymentInstallment,
  paymentTotal,
  paymentValue,
}: ICheckoutButtonCommit8Props) => {
  const { installment, sendingPurchase, isPurposeCardUpdate } =
    useCheckoutContext()

  const textButton = isPurposeCardUpdate() ? "Atualizar cartão" : "Fazer pedido"
  const isInstallment = paymentsInstallment.includes(paymentMethodType)

  let installmentValue = 0

  if (installment?.checkout && installment?.checkout !== null) {
    const installments = installment?.checkout.find(
      (i) => i.installmentNumber === paymentInstallment
    )
    if (installments) {
      installmentValue = installments.total
    }
  }

  const totalText = isInstallment
    ? NumberFunctions.formatMoneyDefault(
        NumberFunctions.round(installmentValue)
      )
    : NumberFunctions.formatMoneyDefault(paymentTotal)

  return (
    <>
      <Box height="80px" />
      <Box
        position="fixed"
        left="-8px"
        right="-8px"
        bottom="0px"
        width="calc(100% + 16px)"
        zIndex={1000}
      >
        <Paper
          sx={{
            p: 2,
            border: "1px solid #DCDDDE",
            borderRadius: "0px",
            backgroundColor: "#ffffff",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="end"
            spacing={1}
            sx={{ width: "100%", pt: 0 }}
          >
            <Box>
              <Stack
                direction="row"
                spacing={1}
                alignItems="end"
                justifyContent="end"
              >
                <Typography fontSize="16px" lineHeight="20px" fontWeight={500}>
                  Total
                </Typography>
                <Typography
                  fontSize="24px"
                  lineHeight="26px"
                  fontWeight={600}
                  color="#EA5455"
                >
                  {totalText}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="end"
              >
                <Typography fontSize="12px" lineHeight="18px" fontWeight={400}>
                  Economizou
                </Typography>
                <Typography fontSize="12px" lineHeight="18px" color="#EA5455">
                  {NumberFunctions.formatMoneyDefault(49)}
                </Typography>
              </Stack>
            </Box>
            <Button
              id="buttonCommit"
              type="submit"
              variant="contained"
              disabled={sendingPurchase}
              style={{
                height: 55,
                textTransform: "none",
                border: "0px solid black",
                //borderRadius: "50px",
                color: "#000",
                backgroundColor: sendingPurchase ? "#85868A" : "#ffd57f",
              }}
              //sx={{ fontWeight: 700, fontSize: "22px", lineHeight: "32px" }}
              data-testid="buttonCommit"
              //startIcon={<HttpsIcon />}
            >
              <Typography fontWeight={700} fontSize="16px" lineHeight="22px">
                {textButton}
              </Typography>
            </Button>
          </Stack>
        </Paper>
      </Box>
    </>
  )
}

export default CheckoutButtonCommit8
